import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'app-storage-form',
  templateUrl: './storage-form.component.html',
  styleUrls: ['./storage-form.component.scss']
})
export class StorageFormComponent implements OnInit {
  uploadPercent: Observable<number>;
  downloadURL: Observable<string>;
  selectedFiles: FileList;
  constructor(private storage: AngularFireStorage) { }
  uploadFiles(event) {
    this.selectedFiles = event.target.files;
    const files = this.selectedFiles;
    const filesIndex = _.range(files.length);
    _.each(filesIndex, (idx) => {
      const file = files[idx];
      const filePath = `blob/${file.name}`;
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, file);
     // observe percentage changes
      this.uploadPercent = task.percentageChanges();
      task.snapshotChanges().pipe(
      finalize(() => this.downloadURL = fileRef.getDownloadURL() )
   )
  .subscribe();

    }
    );

  }


 ngOnInit(): void {

}
  }



